// extracted by mini-css-extract-plugin
module.exports = {"rowHover":"styles_rowHover__1T-JU","tableRow":"styles_tableRow__3Ic9V","coalitions":"styles_coalitions__3koqN","coalitionItem":"styles_coalitionItem__FJwV0"};